<ng-container *ngIf="isMobile$ | async; else desktopMode">
	<div
		(click)="!this.isLoading && this.editTime(entry)"
		[class]="'group-entry pos-relative m-group-entry mat-bg-3-hover ' + this.class"
		[style]="this.style"
		*ngIf="!isPendingDeletion"
	>
		<app-loader
			[enableCircle]="true"
			[isActive]="this.isLoading"
			[isAfterViewInit]="false"
		></app-loader>
		<div class="flex flex-row items-center justify-start space-x-3">
			<div class="flex min-w-0 flex-1 flex-col truncate">
				<span class="truncate">{{ (entry$ | async)?.name || ('time.none' | translate) }}</span>
				<div class="flex flex-row items-center space-x-1">
					<span class="mat-hint flex-shrink-0 truncate text-sm">{{
						(entry$ | async)?.project | defaultEntityTranslate: 'project' : 'project.none'
					}}</span>
					<div class="mat-bg-30 h-1 w-1 flex-shrink-0 rounded-full"></div>
					<span class="mat-hint truncate text-sm">{{
						(entry$ | async)?.task?.name || ('task.none' | translate)
					}}</span>
				</div>
			</div>
			<div class="!ml-auto flex flex-row items-center justify-start space-x-2">
				<mat-icon
					[ngClass]="(entry$ | async)?.billable ? { 'mat-accent': true } : { 'mat-hint': true }"
					class="group-header-icons"
					inline
				>
					attach_money
				</mat-icon>
				<div
					*ngIf="entry$ | async as entry"
					class="flex flex-shrink-0 flex-col space-x-0.5"
				>
					<small> {{ entry.timeDiff | parseMsAsDuration }}</small>
					<small *ngIf="mode !== 'duration' && entry.start && entry.end">
						{{ entry.start | dfnsParseIso | formatDate: 'time' }}-
						{{ entry.end | dfnsParseIso | formatDate: 'time' }}
					</small>
				</div>
				<div class="relative flex items-center">
					<button
						[disabled]="isLoading || group.disabled"
						[matMenuTriggerData]="{ $implicit: entry }"
						[matMenuTriggerFor]="mobileMenu"
						mat-icon-button
					>
						<mat-icon>more_vert</mat-icon>
					</button>
					<ng-container *ngTemplateOutlet="menuNoticeBadge; context: { $implicit: entry }"></ng-container>
				</div>
			</div>
		</div>
	</div>
</ng-container>
<ng-template #desktopMode>
	<form
		[class]="'group-entry pos-relative ' + this.class"
		[formGroup]="group"
		[style]="this.style"
		*ngIf="!isPendingDeletion"
	>
		<div class="flex flex-row items-center justify-start space-x-3">
			<div class="flex min-w-0 flex-auto flex-row items-center justify-start">
				<mat-form-field
					appearance="fill"
					class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain min-w-0 flex-auto"
				>
					<input
						(keydown.enter)="$event.preventDefault(); $event.stopPropagation()"
						[placeholder]="'time.add-name' | translate"
						formControlName="name"
						matInput
						type="text"
					>
					<div
						*ngIf="projectView$ | async as val"
						class="flex h-full flex-row items-stretch justify-start space-x-2"
						matSuffix
					>
						<mat-divider
							class="mat-divider-vertical h-5 self-center"
							vertical
						></mat-divider>
						<span
							(click)="$event.preventDefault(); this.openProjectPicker(entry, $event)"
							(keyup.enter)="$event.preventDefault(); this.openProjectPicker(entry, $event)"
							[class.cursor-pointer]="!isLoading && !group.disabled"
							[matTooltipOptions]="{ interactive: true, delay: [500, 1500] }"
							[matTooltipTemplate]="projectPickerTooltip"
							[matTooltipTemplateContext]="projectTooltipData$ | async"
							class="flex flex-row items-center justify-start gap-1.5"
							matTooltip
							tabindex="0"
						>
							<div
								[style.backgroundColor]="color"
								*ngIf="val.project.color ?? getProjectColor(val.project.id) as color"
								class="project-color-dot -mt-px"
							></div>
							<span>
								{{
									val.project | defaultEntityTranslate: 'project' : 'project.none' | truncate: 20
								}}</span
							>
							<div class="mat-bg-30 h-1 w-1 flex-shrink-0 rounded-full"></div>
							<span>{{
								(val.task?.name || ('task.none' | translate))
										| truncate: (isBelow1100$ | async) ? 10 : 25
							}}</span>
						</span>
					</div>
				</mat-form-field>
			</div>
			<div class="flex flex-row items-center justify-start space-x-2.5">
				<div
					#tagPickerRef="nativeElement"
					class="entry-tags flex flex-row items-center justify-end"
					elementRef
				>
					<ng-container *ngIf="tagTooltipData$ | async as tagTip">
						<button
							(click)="openTagPicker($event)"
							[class.mat-accent]="tagTip.allTags?.length > 0"
							[disabled]="this.isLoading"
							[matTooltipDisabled]="!tagTip.allTags?.length"
							[matTooltipTemplate]="tagPickerTooltip"
							[matTooltipTemplateContext]="tagTip"
							[ngClass]="{ '!cursor-default': isLoading || group.disabled }"
							class="mat-button-icon-sm"
							mat-icon-button
							matTooltip
						>
							<mat-icon
								class
								inline
							>
								label
							</mat-icon>
						</button>
					</ng-container>
				</div>
				<button
					(click)="toggleBilled()"
					[disabled]="this.isLoading"
					[matTooltip]="'time.billability' | translate"
					[ngClass]="{ '!cursor-default': isLoading || group.disabled }"
					*ngIf="!isDisabledFlag"
					class="mat-button-icon-sm"
					mat-icon-button
				>
					<mat-icon
						[class.mat-accent]="group.value.billable"
						class
						inline
					>
						attach_money
					</mat-icon>
				</button>
				<ng-container
					*ngTemplateOutlet="
            mode === 'range'
              ? rangeModeTemplate
              : mode === 'range_optional'
                ? stateVisibleMode
                  ? rangeModeTemplate
                  : durationModeTemplate
                : mode === 'duration'
                  ? durationModeTemplate
                  : null
          "
				></ng-container>
			</div>
			<div class="relative">
				<button
					(menuClose)="dialogOpen = false"
					(menuOpened)="dialogOpen = true"
					[disabled]="isLoading || group.disabled"
					[matMenuTriggerData]="{ $implicit: entry }"
					[matMenuTriggerFor]="settingsMenu"
					mat-icon-button
				>
					<mat-icon>more_vert</mat-icon>
					<ng-container *ngTemplateOutlet="menuNoticeBadge; context: { $implicit: entry }"></ng-container>
				</button>
				<mat-menu
					[overlapTrigger]="true"
					#settingsMenu="matMenu"
					class="py-0"
				>
					<div class="flex flex-col space-y-1">
						<ng-container
							*ngTemplateOutlet="menuNoticeTemplate; context: { $implicit: entry }"
						></ng-container>
						<ng-container
							*ngTemplateOutlet="desktopContinueTime; context: { $implicit: entry }"
						></ng-container>
						<button
							(click)="toggleStateVisibleMode()"
							[disabled]="isLoading || !entry.currentUserCanEdit"
							*ngIf="mode === 'range_optional'"
							mat-menu-item
							type="button"
						>
							<mat-icon>swap_horiz</mat-icon>
							{{ 'timer.time.changeInputMode' | translate }}
						</button>
						<mat-divider></mat-divider>

						<button
							(click)="this.openCalPicker(entry)"
							[disabled]="isLoading || !entry.currentUserCanEdit"
							mat-menu-item
							type="button"
						>
							<mat-icon>date_range</mat-icon>
							{{ 'date.change' | translate }}
						</button>
						<button
							(click)="this.updateTime(group.value)"
							[disabled]="isLoading || group.invalid || !entry.currentUserCanEdit"
							mat-menu-item
						>
							<mat-icon>save</mat-icon>
							{{ 'utils.save' | translate }}
						</button>
						<mat-divider></mat-divider>
						<button
							(click)="deleteEntry(entry)"
							[disabled]="isLoading || !entry.currentUserCanEdit"
							mat-menu-item
						>
							<mat-icon>delete</mat-icon>
							{{ 'utils.delete' | translate }}
						</button>
					</div>
				</mat-menu>
			</div>
		</div>
	</form>
</ng-template>
<mat-menu #mobileMenu="matMenu">
	<ng-template
		let-entry
		matMenuContent
	>
		<div class="flex flex-col space-y-1">
			<ng-container *ngTemplateOutlet="menuNoticeTemplate; context: { $implicit: entry }"></ng-container>
			<ng-container *ngTemplateOutlet="mobileContinueTime; context: { $implicit: entry }"></ng-container>
			<mat-divider></mat-divider>
			<button
				(click)="editTime(entry)"
				[disabled]="!entry.currentUserCanEdit || group.disabled"
				mat-menu-item
			>
				<mat-icon>edit</mat-icon>
				{{ 'utils.edit' | translate }}
			</button>
			<mat-divider></mat-divider>
			<button
				(click)="deleteEntry(entry)"
				[disabled]="!entry.currentUserCanEdit || group.disabled"
				mat-menu-item
			>
				<mat-icon>delete</mat-icon>
				{{ 'utils.delete' | translate }}
			</button>
		</div>
	</ng-template>
</mat-menu>
<ng-template
	#desktopContinueTime
	let-entry
>
	<ng-container
		*ngTemplateOutlet="(this.isManualMode$ | async) ? manualMode : automaticMode; context: { $implicit: entry }"
	></ng-container>
</ng-template>
<ng-template
	#mobileContinueTime
	let-entry
>
	<ng-container *ngTemplateOutlet="automaticMode; context: { $implicit: entry }"></ng-container>
	<ng-container *ngTemplateOutlet="manualMode; context: { $implicit: entry }"></ng-container>
</ng-template>
<ng-template
	#manualMode
	let-entry
>
	<button
		(click)="this.copyEntry(entry)"
		[disabled]="isLoading || entry.project?.completed || group.disabled"
		mat-menu-item
	>
		<mat-icon class="mat-accent">content_copy</mat-icon>
		{{ 'time.copy' | translate }}
	</button>
</ng-template>
<ng-template
	#automaticMode
	let-entry
>
	<button
		(click)="this.continueEntry(entry)"
		[disabled]="isLoading || entry.project?.completed || group.disabled"
		mat-menu-item
	>
		<mat-icon class="mat-accent">play_circle_filled</mat-icon>
		{{ 'task.continue' | translate }}
	</button>
</ng-template>
<ng-template #skeletonPlaceholder>
	<div class="h-full">
		<div class="mat-skeleton"></div>
	</div>
</ng-template>
<ng-template
	#durationHoverCard
	let-end="end"
	let-start="start"
	let-timeDiff="timeDiff"
>
	<div class="flex flex-row items-center justify-start space-x-1">
		<span>{{ 'timer.time.duration' | translate }}:</span>
		<span>{{ timeDiff | parseMsAsDuration: true }}</span>
	</div>
</ng-template>
<ng-template
	#projectPickerTooltip
	let-client="client"
	let-project="project"
	let-tags="tags"
	let-task="task"
>
	<div class="my-2 flex flex-col space-y-2 px-2.5 wflex-[1_0_220px]">
		<div class="space-y-1">
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				client.single
			</h3>
			<div class="flex flex-row font-semibold items-center">
				<span
					[style.backgroundColor]="clientDisplayColor(client)"
					class="project-color-dot flex-shrink-0 self-center"
				></span>
				<span
					[matTooltip]="client | defaultEntityTranslate: 'client' : 'client.none' : ('client.none' | translate)"
					class="ml-1"
				>
					{{
						(client | defaultEntityTranslate: 'client' : 'client.none' : ('client.none' | translate)) | truncate: 60
					}}
				</span>
			</div>
		</div>
		<div class="space-y-1">
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				project.single
			</h3>
			<div class="flex flex-row items-center">
				<span
					[style.backgroundColor]="getProjectColor(project.id)"
					class="project-color-dot flex-shrink-0 self-center"
				></span>
				<span
					[matTooltip]="project | defaultEntityTranslate: 'project' : 'project.none'"
					class="font-semibold ml-1"
				>
					{{ project | defaultEntityTranslate: 'project' : 'project.none' | truncate: 60 }}
				</span>
			</div>
		</div>
		<div
			*ngIf="(project | projectProxy)?.description as desc"
			class="space-y-1"
		>
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				Description
			</h3>
			<div>{{ desc | truncate: 120 }}</div>
		</div>
		<div class="space-y-1">
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				task.select
			</h3>
			<div class="flex flex-row items-center">
				<span
					[matTooltip]="task?.name || ('task.none' | translate)"
					class="font-semibold"
				>
					{{ (task?.name || ('task.none' | translate)) | truncate: 60 }}
				</span>
			</div>
		</div>
	</div>
</ng-template>
<ng-template
	#tagPickerTooltip
	let-allTags="allTags"
>
	<div class="flex flex-col gap-1.5">
		<div
			*ngFor="let item of allTags; trackBy: trackId"
			class="flex items-center gap-2"
		>
			<span
				[style.backgroundColor]="tagDisplayColor(item)"
				class="project-color-dot flex-shrink-0 !cursor-default !m-0"
			></span>
			<span>{{ item.name }}</span>
		</div>
	</div>
</ng-template>
<ng-template
	#menuNoticeTemplate
	let-entry
>
	<div
		*ngIf="entry.hasTimeOverlap"
		class="alert alert-info cursor-default rounded !py-1.5 !text-sm"
		click.native
	>
		{{ 'time.overlaptime_not_allow_workspace' | translate }}
	</div>
</ng-template>
<ng-template
	#menuNoticeBadge
	let-entry
>
	<div
		(click)="$event.stopPropagation(); $event.preventDefault()"
		class="flex flex-col gap-1.5"
	>
		<div
			*ngIf="entry.hasTimeOverlap"
			class="absolute bottom-full left-full z-10 -mb-2 -ml-2 h-2 w-2 select-none rounded-full bg-red-500"
		></div>
	</div>
</ng-template>
<ng-template #startEndTemplate>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="group.controls.time"
		#timespanRef
		class="flex flex-row items-center justify-end space-x-2.5"
	>
		<div class="w-[86px] flex-shrink-0 pb-0">
			<app-time-input
				(click)="this.selectInput($event, startInpRef)"
				(focus)="this.selectInput($event, startInpRef)"
				[displayFormat]="false"
				#startInp
				#startInpRef="nativeElement"
				elementRef
				formControlName="start"
				placeholder="00:00"
			>
				<ng-template
					let-control="control"
					let-inputPlaceholder="inputPlaceholder"
					timeInputControl
				>
					<mat-form-field
						[matTooltip]="inputPlaceholder | translate"
						appearance="fill"
						class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
						fxFill
					>
						<input
							[formControl]="control"
							matInput
							type="text"
						>
					</mat-form-field>
				</ng-template>
			</app-time-input>
		</div>
		<mat-icon inline>arrow_forward</mat-icon>
		<div class="w-[86px] flex-shrink-0 pb-0">
			<app-time-input
				(click)="this.selectInput($event, endInpRef)"
				(focus)="this.selectInput($event, endInpRef)"
				[displayFormat]="false"
				#endInp
				#endInpRef="nativeElement"
				elementRef
				formControlName="end"
				placeholder="00:00"
			>
				<ng-template
					let-control="control"
					let-inputPlaceholder="inputPlaceholder"
					timeInputControl
				>
					<mat-form-field
						[matTooltip]="inputPlaceholder | translate"
						appearance="fill"
						class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
						fxFill
					>
						<input
							[formControl]="control"
							matInput
							type="text"
						>
					</mat-form-field>
				</ng-template>
			</app-time-input>
		</div>
	</form>
</ng-template>
<ng-template #rangeModeTemplate>
	<ng-container *ngTemplateOutlet="startEndTemplate"></ng-container>
	<div
		[matTooltipTemplate]="durationHoverCard"
		[matTooltipTemplateContext]="entry$ | async"
		class="badge badge-duration cursor-default"
		matTooltip
	>
		{{ entry$timeDiff | async | parseMsAsDuration: false }}
	</div>
</ng-template>
<ng-template #rangeOptModeTemplate>
	<ng-container *ngTemplateOutlet="startEndTemplate"></ng-container>
	<ng-container *ngTemplateOutlet="durationModeTemplate"></ng-container>
</ng-template>
<ng-template #durationModeTemplate>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="group.controls.time"
		#timespanRef
		class="flex flex-row items-center justify-start space-x-2.5"
	>
		<div class="w-[86px] flex-shrink-0 pb-0">
			<tg-duration-input-control
				(click)="this.selectInput($event, endInpRef)"
				(focus)="this.selectInput($event, endInpRef)"
				#endInp
				#endInpRef="nativeElement"
				displayFormat="HH:mm"
				elementRef
				formControlName="duration"
				inputPlaceholder="timer.time.duration"
				placeholder="00:00"
			>
				<ng-template
					durationInputControl
					let-control="control"
					let-inputPlaceholder="inputPlaceholder"
				>
					<mat-form-field
						[matTooltip]="inputPlaceholder | translate"
						appearance="fill"
						class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
						fxFill
					>
						<input
							[formControl]="control"
							matInput
							type="text"
						>
					</mat-form-field>
				</ng-template>
			</tg-duration-input-control>
		</div>
	</form>
</ng-template>
